import { cn } from '@/shadcn-ui/utils';
import { Link } from 'react-router';
import React from 'react';
import Rule from '../../rule';
import { useDisableSpaNavigation } from '@/util-react-router/hooks/use-disable-spa-navigation';

const legalLinks = (disableSpaNavigation: boolean) => [
  { text: 'Privacy Policy', url: '/privacy', reloadDocument: disableSpaNavigation },
  { text: 'Terms of Service', url: '/termsofuse', reloadDocument: disableSpaNavigation },
  { text: 'SMS Privacy Policy', url: 'https://blog.flexcar.com/sms-privacy-policy/' },
  {
    text: 'Flexcar® Membership Agreement',
    url: '/membershipagreement',
    reloadDocument: disableSpaNavigation,
  },
  { text: 'Sitemap', url: '/sitemap', reloadDocument: disableSpaNavigation },
];

interface CopyrightAndLegalLinksProps {
  HEROKU_RELEASE_VERSION?: string;
}

export default function CopyrightAndLegalLinks({
  HEROKU_RELEASE_VERSION,
}: CopyrightAndLegalLinksProps) {
  // eslint-disable-next-line flexcar/no-direct-date
  const thisYear = new Date().getFullYear();

  const { disableSpaNavigation } = useDisableSpaNavigation();

  return (
    <div className="flex w-full flex-col gap-[16px] md:flex-row md:justify-between">
      <p className={cn('homepage-footer flex-shrink-0')}>
        © {thisYear} Flexcar, LLC. All rights reserved.
      </p>

      <div className="flex flex-wrap gap-[8px]">
        {legalLinks(disableSpaNavigation).map((link, index) => (
          <React.Fragment key={`legal-links-subsection-${index}`}>
            <Link
              to={link.url}
              className={cn('homepage-footer hover:underline')}
              reloadDocument={link.reloadDocument}
            >
              {link.text}
            </Link>

            {index !== legalLinks.length - 1 && (
              <Rule direction="vertical" className="h-4 bg-flexcar-neutral80" />
            )}
          </React.Fragment>
        ))}

        {HEROKU_RELEASE_VERSION ? (
          <>
            <Rule direction="vertical" className="h-4 bg-flexcar-neutral80" />
            <p className={cn('homepage-footer')}>{HEROKU_RELEASE_VERSION}</p>
          </>
        ) : null}
      </div>
    </div>
  );
}
